import { render, staticRenderFns } from "./DynamicRegisterBank.vue?vue&type=template&id=13592282"
import script from "./DynamicRegisterBank.vue?vue&type=script&lang=js"
export * from "./DynamicRegisterBank.vue?vue&type=script&lang=js"
import style0 from "./DynamicRegisterBank.vue?vue&type=style&index=0&id=13592282&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports